import React, { useState, createRef, useEffect } from 'react';
import * as htmlToImage from 'html-to-image';
import { ParseAnswer } from 'components/questions/Question';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';
import axios from 'axios';
import canvasToImage from 'canvas-to-image';
import { useGlobalContext } from 'context/GlobalContext';
import { surveyApi } from 'api/surveyApi';
import MetaTagHolder from 'components/MetaTagHolder';
import { LeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import RenderResultDesc from './RenderResultDesc';
import { FiShare2 } from 'react-icons/fi';
import { BiScreenshot } from 'react-icons/bi';
import { Chart } from 'react-chartjs-2';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from 'react-device-detect';

function handleDownload(attempts) {
  const element = document.getElementById('root');
  htmlToImage.toCanvas(element).then(function (canvas) {
    const context = canvas.getContext('2d');
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    // console.log(attempts,imageData.data.indexOf(12), imageData.data)
    if (imageData.data.indexOf(12) !== -1 || attempts >= 10) {
      // chỗ này dùng indexOf(12) vì border chart có rgba có điểm màu 12, đã test trước
      // là điểm màu 12 chỉ tồn tại ở radar chart
      // nên khi radar chart render xong thì mới tồn tại điểm màu 12
      document.body.appendChild(canvas);
      // phần code này sử dụng thư viện canvas-to-image để download, để tạm đây xóa sau
      // canvas.id = 'temp_result';
      // canvasToImage('temp_result', {
      //   name: `result`,
      //   type: 'png',
      //   quality: 1,
      // });

      var a = document.createElement('a'); //Create <a>
      a.href = canvas.toDataURL(); //Image Base64 Goes here
      a.download = 'result.png'; //File name Here
      a.click(); //Downloaded file
      document.body.removeChild(canvas);
    } else {
      console.log(
        `Trying Safari rendering again (attempt #${attempts + 1})...`
      );
      setTimeout(() => handleDownload(attempts + 1), 1000);
      return;
    }

    document.getElementById('share-btn').style.display = 'flex';
    document.getElementById('screenshot-btn').style.display = 'flex';
  });
}

const TestingResult = () => {
  //SHARE
  const [toggleShare, setToggleShare] = useState(false);
  const [image, setImage] = useState('');

  const user = {
    result: {
      percentile: 10,
      properties: [2, null, 0, 0, 2, 1.5],
    },
    userId: '5c275e9d-bfcd-4469-a202-7d6d23bd4dd',
  };

  // result đây nha ông
  //ok ong

  const handleShare = () => {
    setToggleShare(true);
  };

  const handleShareDesktop = async (platform) => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: 3177030649181111,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v13.0',
      });

      window.FB.ui(
        {
          method: platform === 'facebook' ? 'share' : 'send',
          link: 'https://developers.facebook.com/docs/',
          href: 'https://developers.facebook.com/docs/',
        },
        function (response) {
          console.log(response);
        }
      );
    };
    window.fbAsyncInit();

    const shareapi =
      platform === 'facebook'
        ? await surveyApi.share(user.userId, 1)
        : await surveyApi.share(user.userId, 2);
    console.log(shareapi);
  };

  //SHARE ANDROID
  const handleShareAndroid = async () => {
    const shareData = {
      title: 'MedX',
      text: `DuyTung đã phù hợp đến ${user.result.percentile} điểm, còn bạn?`,
      url: 'https://this_is_testing',
    };

    try {
      await navigator.share(shareData);
    } catch (err) {
      console.log(`Sharing error: ${err}`);
    }
  };

  //CHART
  ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
  );

  const chartData = {
    labels: [
      'Trực giác với ngành',
      'Khả năng',
      'Đam mê ngành',
      'Thấu hiểu bản thân',
      'Điều kiện gia đình',
      'Tự nhận xét',
    ],
    datasets: [
      {
        label: null,
        data: user.result.properties || [],
        backgroundColor: 'rgba(252, 105, 162, 0.5)',
        borderColor: '#fd68a2',
        borderWidth: 1,
      },
    ],
    options: {
      legend: { display: false },
    },
  };

  //SCREENSHOT

  const handleScreenshot = async () => {
    try {
      document.getElementById('share-btn').style.display = 'none';
      document.getElementById('screenshot-btn').style.display = 'none';
      handleDownload(0);
      const screenshotapi = await surveyApi.screenshot(user.userId);
      console.log(screenshotapi);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="bg-gradient_peach_result w-full relative -mb-3">
      <MetaTagHolder
        info={{
          ratio: user.result.percentile,
          username: localStorage.getItem('name'),
        }}
      />
      <div className="px-6  mx-auto">
        <div className="float-left my-6 text-xl flex items-center">
          <Link to="/dang-nhap">
            <LeftOutlined />
          </Link>
        </div>
        <div className="bg-white py-5 px-4 rounded-xl w-full flex flex-col items-center justify-between ">
          <div className=" text-center text-4xl font-bold text-white rounded-full w-full">
            <Radar data={chartData} id="my-canvas" />
          </div>
          <div className="text-[#FC69A2] text-5xl font-extrabold w-full text-center">
            <p>{user.result.percentile}%</p>
          </div>
          <div className="flex w-full justify-between mt-6 gap-x-3">
            <button
              id="screenshot-btn"
              onClick={handleScreenshot}
              className="flex-1 rounded-full text-sm bg-[#ffe8f1] text-[#FC69A2] py-3 flex font-semibold gap-x-1.5 items-center justify-center text-center"
            >
              <span className="">Chụp màn hình</span>

              <BiScreenshot className="text-[#FC69A2] text-lg" />
            </button>
            <button
              id="share-btn"
              onClick={isMobile ? handleShareAndroid : handleShare}
              className="flex-1 rounded-full text-sm bg-[#ffe8f1] text-[#FC69A2] py-3 flex font-semibold gap-x-1.5 items-center justify-center"
            >
              <span>Chia sẻ kết quả</span>

              <FiShare2 className="text-[#FC69A2] text-lg" />
            </button>
          </div>
        </div>
        <div className="">
          <h3 className="text-2xl font-semibold text-center mx-auto my-6">
            {localStorage.getItem('name')}
          </h3>
          <p className="text-justify font-light pb-6">
            <RenderResultDesc result={user.result.percentile} />
          </p>
        </div>
        <div
          className={`bg-white w-full z-20 h-48 absolute left-0 right-0 bottom-0 p-6 justify-between ${
            toggleShare && isBrowser ? 'flex flex-col' : 'hidden'
          }`}
        >
          <span className="font-semibold text-[#FC69A2]">Chia sẻ</span>
          <div className="flex items-center justify-between text-center text-sm mb-2">
            <button onClick={() => handleShareDesktop('facebook')}>
              <img
                src="icons/facebook-icon.svg"
                alt="facebook icon"
                className="mx-auto my-2 w-10 h-10"
              />
              <span>Facebook</span>
            </button>
            <button onClick={() => handleShareDesktop('messenger')}>
              <img
                src="icons/messenger-icon.svg"
                alt="messenger icon"
                className="mx-auto my-2 w-10 h-10"
              />
              <span>Messenger</span>
            </button>
            <button>
              <img
                src="icons/zalo-icon.svg"
                alt="zalo icon"
                className="mx-auto my-2 w-10 h-10"
              />
              <span>Zalo</span>
            </button>
          </div>
        </div>
      </div>
      <div
        className={`absolute h-screen z-10 w-full bg-gray-500 opacity-50 top-0 bottom-0 right-0 left-0 ${
          toggleShare ? 'block' : 'hidden'
        }`}
        onClick={() => setToggleShare(false)}
      ></div>
    </div>
  );
};

export default TestingResult;
